<template>
  <div class="of-home">
    <div v-show="showLoader" class="loader" :class="{ hidden: !showLoader }">
      <div class="loader-wrapper">
        <div class="block loader-block-1"></div>
        <div class="block loader-block-2"></div>
        <div class="block loader-block-3"></div>
        <div class="block loader-block-1"></div>
        <div class="block loader-block-2"></div>
        <div class="block loader-block-3"></div>
      </div>
    </div>
    <div class="global-container">
      <div class="home__head">
        <div class="home__headlines">
          <p>helping heads – projektentwicklung</p>
          <h1>Umwerfende Konzepte</h1>
          <h1>Unvergessliche Erlebnisse</h1>
        </div>
        <div class="home__buttons">
          <BaseBtn variant="primary" scrollTo=".home__intro"
            >Mehr erfahren</BaseBtn
          >
          <BaseBtn variant="primary" to="/projekte">Alle Projekte</BaseBtn>
        </div>
      </div>

      <homeGallery class="home-gallery" />

      <div class="home__intro">
        <H2Text
          headline="Was machen wir genau?"
          text="Wir gestalten neuartige Ideen, einzigartige Installationen und
          inhaltlich wertvolle Großprojekte. Wir beschäftigen uns seit Jahren mit
          Licht und Projektionen. Weiters bauen wir Sonderkonstruktionen und
          entwickeln eher unkonventionelle Konzepte für Events und Projekte.
          Außerdem bieten wir (mobile) Wasserwände, Wasservorhänge, Wasserspiele-/shows
          und mobile (Indoor) Wasserfontänen an. Wir sehen uns als Ideenschmiede
          und Berater für außergewöhnliche Auftritte unserer Kunden."
        />
      </div>

      <div class="home__categories">
        <div class="cat_flex">
          <h2>Unsere Projektkategorien</h2>
          <p>Tippe auf eine Kategorie, um mehr zu erfahren.</p>
        </div>
        <div class="home__cat__wrapper">
          <HomeKategorie
            category="Gestaltungen"
            description="Wir beschäftigen uns seit Jahren mit Gestaltungen aller Art. Sowohl von Events wie Konzerte und Festivals, als auch von Landschaften, Baustellen, Messen und Märkten. Wir konzentrieren uns hierbei auf Kunst, interaktive Areas und lichtvolle Austellungen."
          />
          <HomeKategorie
            category="Licht"
            description="Eines unserer Spezialgebiete ist das Licht. Wir fokussieren uns auf Projektionen, Leuchtballons, Feuerschalen und Lichtspiele. Wir arbeiten hier mit hochentwickelten Projektoren, LED Spots, Lichterketten und weiterem. Unser Ziel ist es, ein umwerfendes Schauspiel zu erschaffen, welches unsere Kund*innen und Zuschauer*innen begeistert."
          />
          <HomeKategorie
            category="Projektionen"
            description="Mittels Großflächenprojektionen lassen sich recht einfach eindrucksvolle Optiken erschaffen. Wir projizieren auf alle möglichen Untergründe. Sei es auf Rasen in riesigen Fußballstadien, auf schneebedeckte Hänge oder Pisten in Skigebieten, auf Bäume oder Baumgruppen bei Festen und Partys, oder einfach auf Hausfassaden. Unsere extrem lichtstarke Dia- und Videoprojektoren zeigen Kunst in überdimensionalen Formaten oder übermitteln in riesigen Buchstaben Werbebotschaften. Sie sind sehr schnell und dank speziell konstruierter Gehäuse und Projektionstürmen überall einsetzbar."
          />
          <HomeKategorie
            category="Sonderkonstruktionen"
            description="In den letzten Jahren wurde der Sektor Sonderkonstruktionen für uns sehr groß. Wir konzentrieren uns hier vollkommen auf die Wünsche unserer Kund*innen und ermöglichen so neue und kreative Konstruktionen, welche man so noch nicht gesehen hat. Unser Fokus liegt hierbei bei großen Schriftzügen, Werbe-Artikel, Kunst-Installationen und besonderen Statuen."
          />
          <HomeKategorie
            category="Wasser"
            description="Wir arbeiten hier mit Pumpen, Wasserbecken und Düsen, welche uns ermöglichen, einzigartige Inszenierungen zu erschaffen. Unser Fokus liegt auf unseren bekannten Wasserwänden, welche bei unseren Kund*innen sehr beliebt sind. Weiters beschäftigen wir uns mit künstlerischen Botschaften, die wir auf jegliche Art von Wasser projizieren oder zeigen."
          />
        </div>
        <div class="btn__flex">
          <BaseBtn variant="primary" to="/projekte">Alle Projekte</BaseBtn>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseBtn from "@/components/BaseBtn.vue";
import H2Text from "@/components/h2Text.vue";
import HomeKategorie from "@/components/HomeKategorie.vue";
import homeGallery from "@/components/homeGallery.vue";

import { gsap } from "gsap";
import { ref, onMounted } from "vue";

const showLoader = ref(true);

onMounted(() => {
  if (!sessionStorage.getItem("visited")) {
    gsap.fromTo(
      ".block",
      { y: 0 },
      {
        y: "-100%",
        duration: 1,
        stagger: 0.25,
        ease: "power2.inOut",
      }
    );

    setTimeout(() => {
      const loader = document.querySelector(".loader");
      loader?.classList.add("hidden");

      setTimeout(() => {
        showLoader.value = false;
        sessionStorage.setItem("visited", "true");
      }, 600);
    }, 250 * 6 + 1000);
  } else {
    showLoader.value = false;
  }
});
</script>

<style scoped lang="scss">
.of-home {
  overflow-x: hidden;
  .loader {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    transition: opacity 0.6s ease;
    background: transparent;

    &.hidden {
      opacity: 0;
      pointer-events: none;
    }

    .loader-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      .loader-block-1,
      .loader-block-2,
      .loader-block-3 {
        width: calc(100vw / 6);
        height: 100%;
        border-bottom-right-radius: 999px;
        border-bottom-left-radius: 999px;
      }
      .loader-block-1 {
        background-color: $bg--col;
      }
      .loader-block-2 {
        background-color: $text--col;
      }
      .loader-block-3 {
        background-color: $brand--col;
      }
    }
  }
  .home__head {
    height: 90vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    gap: map-get($spaces, "xxl");
    text-align: center;
    position: relative;
    z-index: 1;
    p {
      color: $text--greyed;
      font-style: italic;
      margin-bottom: map-get($spaces, "md");
      letter-spacing: 1px;
      @media (max-width: 500px) {
        letter-spacing: 0;
        font-size: 1rem;
        margin-bottom: map-get($spaces, "sm");
      }
    }
    h1 {
      margin-top: map-get($spaces, "xs");
      text-transform: uppercase;
      @media (max-width: 500px) {
        font-size: 1.4625rem;
      }
      @media (max-width: 400px) {
        font-size: 1.2625rem;
      }
    }
    .home__buttons {
      position: absolute;
      bottom: 10%;
      display: flex;
      align-items: center;
      gap: map-get($spaces, "md");
    }
  }
  .home__intro {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    @media (max-width: 500px) {
      margin-top: 10vh;
      margin-bottom: 10vh;
    }
  }
  .home__categories {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: map-get($spaces, "xl");
    .cat_flex {
      display: flex;
      flex-direction: column;
      gap: map-get($spaces, "xs");
      p {
        color: $text--muted;
      }
      @media (min-width: 1440px) {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
      }
    }
    .home__cat__wrapper {
      margin-bottom: map-get($spaces, "md");
    }
    .btn__flex {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
